import React, { ReactElement } from 'react';
import Loader from 'react-loading-overlay';
import { ILoaderProps } from './types/LoaderStyled';
Loader.propTypes = undefined; // workaround for console error on styles.content

// This fixes IE11 issue on spinner trail not showing
const LoaderStyled = (props: ILoaderProps): ReactElement => {
  if (props.barLoader) {
    return (
      // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
      <Loader
        {...props}
        styles={{
          overlay: (base: React.CSSProperties) => ({
            ...base,
            background: props.background || 'none',
            top: props.topPosition,
          }),
          content: (contentStyle: React.CSSProperties) => ({
            ...contentStyle,
            color: props.color,
          }),
          spinner: (base: React.CSSProperties) => ({
            ...base,
            color: props.color,
            '& svg circle': {
              stroke: props.color,
              strokeDasharray: '20, 200',
            },
          }),
        }}
      />
    );
  }

  return (
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    <Loader
      {...props}
      styles={{
        overlay: (overlayStyle: React.CSSProperties) => ({
          ...overlayStyle,
          background: props.background || 'none',
          top: props.topPosition,
          opacity: props.opacity,
          heigh: '100%',
        }),
        content: (base: React.CSSProperties) => ({
          ...base,
          color: props.color,
          fontSize: props.fontSize,
          minHeight: 60,
        }),
        spinner: (spinnerStyle: React.CSSProperties) => ({
          ...spinnerStyle,
          color: props.color,
          '& svg circle': {
            stroke: props.color,
            strokeDasharray: '20, 200',
          },
        }),
      }}
      className="loader-rotate-fix"
    />
  );
};

LoaderStyled.defaultProps = {
  spinner: true,
  text: 'Loading...',
  color: '#E21D4A',
  zindex: 999,
};

export default LoaderStyled;
